// RegistrationPrompt.jsx
import React from "react";
import { Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const RegistrationPrompt = ({ navigate }) => {
  return (
    <Box sx={{ marginTop: "40px", gap: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography sx={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "16px", lineHeight: "100%" }}>
        Don't have an account?
        <span
          onClick={() => navigate("/register")}
          style={{ color: "#20A8E0", cursor: "pointer", marginLeft: "5px" }}
        >
          Register Now
        </span>
      </Typography>
     <span style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "16px", cursor: "pointer", border:"none"}}>
        <a 
          href="https://routeeye.io/support/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: "#20A8E0", textDecoration: "none" }}
        >
          Need Help?
        </a>
      </span>
    </Box>
  );
};

export default RegistrationPrompt;